'use strict';

var _glamor = require('glamor');

var _HelveticaNikePlus_Light = require('./HelveticaNikePlus_Light.otf');

var _HelveticaNikePlus_Light2 = _interopRequireDefault(_HelveticaNikePlus_Light);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_glamor.css.global('@font-face', {
  fontFamily: 'HelveticaNikePlus',
  fontWeight: 'lighter',
  src: 'url(' + _HelveticaNikePlus_Light2.default + ') format(\'opentype\')'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/HelveticaNikePlus/HelveticaNikePlus_Light.js
// module id = 884
// module chunks = 0